/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Eloshield proximity zone
 * @export
 * @enum {string}
 */
export enum ProximityZone {
    NONE = 'none',
    ZONE2 = 'zone2',
    ZONE1 = 'zone1'
}


export function instanceOfProximityZone(value: any): boolean {
    for (const key in ProximityZone) {
        if (Object.prototype.hasOwnProperty.call(ProximityZone, key)) {
            if (ProximityZone[key as keyof typeof ProximityZone] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProximityZoneFromJSON(json: any): ProximityZone {
    return ProximityZoneFromJSONTyped(json, false);
}

export function ProximityZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProximityZone {
    return json as ProximityZone;
}

export function ProximityZoneToJSON(value?: ProximityZone | null): any {
    return value as any;
}

export function ProximityZoneToJSONTyped(value: any, ignoreDiscriminator: boolean): ProximityZone {
    return value as ProximityZone;
}

